class CartItemGallery extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.parent = this.closest('.cart-item--expands');
        if (!this.parent) return console.warn('All cart item galleries need expanding parent.');
        this.init();
    }

    init() {
        this.gapSize = this.getCSSVariable('--gallery-gap-size');
        this.imageSize = this.getCSSVariable('--gallery-image-size');
        this.galleryRowSize = this.imageSize + this.gapSize;

        window.addEventListener('resize', this.setRows.bind(this));
        this.addEventListener('click', this.handleClick.bind(this));

        this.setRows();
    }

    /**
     * Handles the click event.
     * Toggles the 'open' attribute on the element if the event target matches the 'js-toggle-gallery' class.
     *
     * @param {Event} evt - The click event.
     */
    handleClick(evt) {
        // Check if the event target has the 'js-toggle-gallery' class
        if (evt.target.classList.contains('js-toggle-gallery')) {
            this.toggleAttribute('open');
        }
    }

    getCSSVariable(varName) {
        const str = getComputedStyle(this.parent).getPropertyValue(varName).trim();

        return Number(str.replace('px', ''));
    }

    setRows() {
        const rows = (this.offsetHeight + this.gapSize) / this.galleryRowSize;
        this.classList.toggle('show-more', rows > 1);
        this.parent.style.setProperty('--gallery-rows', rows);
    }
}
customElements.define('cart-item-gallery', CartItemGallery);
